module.exports = __webpack_public_path__ + "img/1.36b54947.png";